import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  editPanelInput: {
    marginBottom : 30
  },
}));
